import angular, { ILogService, ITimeoutService } from 'angular'
import { FormSelect } from 'materialize-css'

type DirectiveInstance = {
  selectInstance: null | FormSelect
}

class MaterialTextareaDirective implements ng.IDirective {
  require = 'ngModel'

  constructor(private $log: ILogService, private $timeout: ITimeoutService) {}

  link = (scope: ng.IScope, $element: JQLite, attrs: ng.IAttributes, ctrls: ng.IDirectiveController) => {
    let instance: DirectiveInstance = {
      selectInstance: null,
    }

    this.$log.info('==== attr texta', attrs)

    scope.$watch(attrs.ngModel, (newVal, oldVal) => {
      this.$log.info('==', newVal, scope, $element, ctrls)

      let _instance = this._initInstance($element, instance)

      if (!newVal) {
        // limpia el model
        _instance && (_instance.input.value = '')
      }
    })

    this.$timeout(() => $element.formSelect(), 100)
  }

  private _initInstance($element: JQLite, instance: DirectiveInstance) {
    if (!instance.selectInstance) instance.selectInstance = M.FormSelect.getInstance($element[0])

    return instance.selectInstance
  }
}

angular
  .module('candidato')
  .directive(
    'materialTextareaCaxton',
    ($log: ILogService, $timeout: ITimeoutService) => new MaterialTextareaDirective($log, $timeout)
  )
